import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { setupGlobalErrorHandlers, logger } from "./lib/observability";
import { initSentry } from "./lib/sentry";
import { initBuildVersionGuard, getBuildId } from "./lib/buildVersion";
import { redirectAliasHostToCanonical } from "./lib/canonicalHost";

// Alias hosts (.gg / www) must not boot the SPA — they split cookies and SEO.
if (!redirectAliasHostToCanonical()) {
  // Purge stale caches/service workers and watch for newer deploys.
  initBuildVersionGuard();

  // Initialize Sentry for error tracking (when configured)
  initSentry();

  // Initialize global error handlers for observability
  setupGlobalErrorHandlers();

  logger.info("Application starting", {
    version: import.meta.env.VITE_APP_VERSION || "1.0.0",
    buildId: getBuildId(),
    environment: import.meta.env.MODE,
  });

  // Warm the split chunk for the first-painted route *before* React mounts, so the
  // page chunk downloads in parallel with the entry script instead of waiting for
  // the router to resolve. Other routes never pay for these bundles.
  {
    const path = window.location.pathname;
    if (path === "/") void import("./pages/LandingPage");
    else if (path === "/auth" || path === "/login") void import("./pages/UnifiedAuth");
  }

  createRoot(document.getElementById("root")!).render(<App />);
}

// Best-effort IP-based region hint (never overrides a manual pick).
